import * as React from "react"
import { translateCountryName } from "@ui-seeker/utils"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedMarkets, selectedSites } from "../@signals"


export default function SkuCandidatesMarketFilter() {
    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${BACKEND_APIS.SKU_CANDIDATES}/markets`}
        label="Market"
        placeholder="All Markets"
        value={selectedMarkets.value}
        onChange={e => {
            selectedMarkets.value = e.target.value
            if (selectedSites.value?.length > 0) {
                selectedSites.value = []
            }
        }}
        getOptionLabel={({ label }) => translateCountryName(label)}
        formatOptionLabel={({ label }) => <LabelCountry country={label} label={translateCountryName(label)} />}
    />
}
